<div class="dialog-container">
    <div class="dialog-title-block">
        <h4 class="text-heading-4 text-capitalize text-dark">Upload Status</h4>
        <div class="flex-container">
            <div class="dialog-btn" (click)="onClose()">
                <img class="dialog-colse-btn" src="../../../assets/images/close.png" alt="close">
            </div>
        </div>
    </div>
    <div class="dialog-content-block p-3">
        <div class="mb-4">
            <p class="text-para mb-2 text-light-dark">Uploaded Entries : <span class="text-heading-6">{{ dialogData.uploadeEntries ? dialogData.uploadeEntries : 0 }}</span></p>
            <p class="text-para text-light-dark">Invalid Entries : <span class="text-heading-6">{{ dialogData.invalidEntries ? dialogData.invalidEntries : 0 }}</span></p>
        </div>
        <div class="text-center">
            <h5 class="text-heading-5 text-light-dark">Invalid entries will be downloaded automatically.</h5>
            <p class="text-para text-grey-100">
                If your download doesn't start automatically,<br> 
                please <a id="blob-link" class="text-link text-decoration-underline text-primary" href="" target="_blank" download="">click here</a>
            </p>
        </div>
    </div>
    <div class="dialog-footer">
        <button class="px-5 py-2" type="button" (click)="onClose()">Okay</button>
    </div>
</div>
